import React, {useId, useState} from 'react';
import {Button} from "primereact/button";
import {GeneratedDashboardReportResponse} from "api/apiModels";

import {ToastSeverityType} from "primereact/toast";
import {ConfirmPopup} from "primereact/confirmpopup";
import {useMarkForRegeneration} from "api/api-hooks/reports-hooks";

const MarkForRegeneration = (props: {
    rowData: GeneratedDashboardReportResponse,
    showToast(severity: ToastSeverityType,
              summary: string,
              detail: string,
              lifetime: number): void
}) => {
    const id = useId();

    const [popup, setPopup] = useState(false);

    const {mutate: markForRegeneration, isLoading: markedForRegenerationLoading} = useMarkForRegeneration({
        onSuccess: () => {
            props.showToast("success", "", "Report marked for regeneration", 3000)
        },
        onFailure: () => {
            props.showToast("error", "", "Failed to mark report for regeneration", 3000)
        }
    });

    const accept = () => {
        markForRegeneration({genId: [props.rowData.id], lazy: false})
    };

    return (<div className={"flex align-items-center"}>
            <ConfirmPopup target={document.getElementById(id) ?? undefined}
                          visible={popup} onHide={() => setPopup(false)}
                          message="Mark for regeneration?"
                          icon="pi pi-question-circle" accept={accept}/>
            <Button icon={"fa fa-retweet"}
                    id={id}
                    className="p-button-rounded p-button-text p-button-sm"
                    loading={markedForRegenerationLoading}
                    onClick={() => setPopup(true)}
            />
        </div>
    ) || null;
};

export default MarkForRegeneration;